/* unplugin-vue-components disabled */import { render } from "./notice.vue?vue&type=template&id=d9e5ff3e&scoped=true"
import script from "./notice.vue?vue&type=script&lang=js"
export * from "./notice.vue?vue&type=script&lang=js"

import "./notice.vue?vue&type=style&index=0&id=d9e5ff3e&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-案例中心-哈工程-前台页面-saas/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9e5ff3e"]])

export default __exports__